import apiClient from './api';
import type { User } from '@/types';

export const profileService = {
  /**
   * Get current user profile
   */
  async getProfile(): Promise<User> {
    const { data } = await apiClient.get<User>('/user');
    return data;
  },

  /**
   * Update profile
   */
  async updateProfile(profileData: Partial<User>): Promise<User> {
    const { data } = await apiClient.put<User>('/user', profileData);
    return data;
  },

  /**
   * Change password
   */
  async changePassword(passwordData: {
    current_password: string;
    password: string;
    password_confirmation: string;
  }): Promise<{ message: string }> {
    const { data } = await apiClient.post('/user/password', passwordData);
    return data;
  },

  /**
   * Update avatar
   */
  async updateAvatar(file: File): Promise<{ avatar_url: string }> {
    const formData = new FormData();
    formData.append('avatar', file);
    const { data } = await apiClient.post('/user/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  /**
   * Get user sessions
   */
  async getSessions() {
    const { data } = await apiClient.get('/user/sessions');
    return data;
  },

  /**
   * Revoke session
   */
  async revokeSession(sessionId: string): Promise<{ message: string }> {
    const { data } = await apiClient.delete(`/user/sessions/${sessionId}`);
    return data;
  },

  /**
   * Revoke all other sessions
   */
  async revokeAllSessions(): Promise<{ message: string }> {
    const { data } = await apiClient.post('/user/sessions/revoke-all');
    return data;
  },
};
